'use client'

import FormSubmitButton from '@/form/FormSubmitButton'
import classNames from 'classnames'
import styles from '../Debug.module.css'
import { ActionFormProvider, useActionForm } from '@/form/ActionForm'
import { BaseFormOperation } from '@/form/types'
import { LayoutCluster, TextInput } from '@betterplace/design-system/client'
import { ReceiverTypes } from '@betterplace/api-graphql-types'
import { createMultipleDonationsFormSchema } from './types'
import { processMultipleDonationsFormAction } from './operations/processMultipleDonationsAction'
import { useTranslations } from 'next-intl'

function CreateMultipleDonations({ receiverType, receiverId }: { receiverType: ReceiverTypes; receiverId: string }) {
  const formValues = {
    receiverType,
    receiverId,
    number: 1,
  }

  const t = useTranslations()

  const { action, id, ...form } = useActionForm({
    action: processMultipleDonationsFormAction as unknown as BaseFormOperation,
    actionContext: {},
    schema: createMultipleDonationsFormSchema,
    defaultValues: formValues,
    values: formValues,
    defaultErrorMessage: t('nextjs.errors.messages.default'),
    mode: 'all',
    reValidateMode: 'onChange',
  })

  return (
    <div className={classNames(styles.genericAdminBox, styles.forPlatformAdmins, styles.fakeButtonsList)}>
      <h2 className={styles.fakeButtonsHeading}>Create Multiple Donations</h2>
      <ActionFormProvider {...form}>
        <form action={action} id={id}>
          <LayoutCluster>
            <TextInput name="number" type="number" defaultValue={formValues.number} />
            <input type="hidden" {...form.register('receiverType')} defaultValue={formValues.receiverType} />
            <input type="hidden" {...form.register('receiverId')} defaultValue={formValues.receiverId} />
            <FormSubmitButton>Create</FormSubmitButton>
          </LayoutCluster>
        </form>
      </ActionFormProvider>
    </div>
  )
}

export default CreateMultipleDonations
